import { render, staticRenderFns } from "./Scommerce.vue?vue&type=template&id=67c78925&"
import script from "./Scommerce.vue?vue&type=script&lang=js&"
export * from "./Scommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports